export default {
  setItems(datas, keys, isOnlyOutputItemLayers) {
    let result = null
    const {textKey, valueKey, getLayersKey, setLayersKey, fieldKeys} = keys
    if (Array.isArray(datas)) {
      result = []
      datas.forEach((data) => {
        const item = {
          [`${valueKey}`]: data[`${valueKey}`],
        }
        if (textKey && data[`${textKey}`]) {
          item[`${textKey}`] = data[`${textKey}`]
        }
        if (fieldKeys) {
          fieldKeys.forEach((fieldKey) => {
            if (data[`${fieldKey}`] !== undefined){
              item[`${fieldKey}`] = data[`${fieldKey}`]
            }
          })
        }
        if (data[`${getLayersKey}`] && 
        data[`${getLayersKey}`].length > 0) {
          item[`${setLayersKey}`] = this.setItems(data[`${getLayersKey}`], keys)
        }
        result.push(item)
      })
    } else {
      const item = {
        [`${valueKey}`]: datas[`${valueKey}`],
      }
      if (textKey && datas[`${textKey}`]) {
        item[`${textKey}`] = datas[`${textKey}`]
      }
      if (fieldKeys) {
        fieldKeys.forEach((fieldKey) => {
          if (datas[`${fieldKey}`] !== undefined){
            item[`${fieldKey}`] = datas[`${fieldKey}`]
          }
        })
      }
      if (datas[`${getLayersKey}`] && 
      datas[`${getLayersKey}`].length > 0) {
        item[`${setLayersKey}`] = this.setItems(datas[`${getLayersKey}`], keys)
      }
      result = item
    }
    if (isOnlyOutputItemLayers) {
      return result.layers
    } else {
      return result
    }
  },
  constructLayers(layers, valueArr, valueKey, textKey, isSubLayersInvisibleWhenSelectAllSubLayers = false) {
    if (!layers) {
      return []
    }
    if (Array.isArray(valueArr)) {
      const resultArr = []
      layers.forEach((layer) => {
        if (valueArr.includes(layer[`${valueKey}`])) {
          const requiredFieldStateIndex = valueArr.findIndex(
            (state) => state === layer[`${valueKey}`]
          )
          valueArr.splice(requiredFieldStateIndex, 1)
          if (layer.layers) {
            const _layers = this.constructLayers(layer.layers, valueArr, valueKey, textKey)
            if (isSubLayersInvisibleWhenSelectAllSubLayers) {
              const item = {
                [`${valueKey}`]: layer[`${valueKey}`],
                [`${textKey}`]: layer[`${textKey}`],
                layers: []
              }
              if (layer.layers.length !== _layers.length ) {
                item.layers = _layers
              }
              resultArr.push(item)
            } else {
              resultArr.push({
                [`${valueKey}`]: layer[`${valueKey}`],
                [`${textKey}`]: layer[`${textKey}`],
                layers: _layers
              })
            }
          } else {
            resultArr.push({
              [`${valueKey}`]: layer[`${valueKey}`],
              [`${textKey}`]: layer[`${textKey}`],
            })
          }
        }
      })
      return resultArr
    } else {
      return []
    }
  },
  getRootLayers(totalLayers, targetValueArray, valueKey) {
    let rootLayers = totalLayers.filter((layer) => targetValueArray.includes(layer[valueKey]))
    if (rootLayers.length === 0) {
      const rootLayerIdList = []
      totalLayers.forEach((layer) => {
        if (layer.layers) {
          if (this.checkIfAnyLayerIdInTargetValue(layer.layers, targetValueArray)) {
            rootLayerIdList.push(layer.id)
          }
        }
      })
      rootLayers = totalLayers.filter((layer) => rootLayerIdList.includes(layer[valueKey]))
    }
    return rootLayers
  },
  checkIfAnyLayerIdInTargetValue(layers, targetValueArray) {
    if (layers.filter((layer) => targetValueArray.includes(layer.id))) {
      return true
    } else {
      let result = false
      layers.forEach((layer) => {
        if (layer.layers && !result) {
          result = this.checkIfAnyLayerIdInTargetValue(layer.layers, targetValueArray)
        }
      })
      return result
    }
  },
};
